import { FormattedMessage } from "react-intl";
import { pollManagement } from "./pollManagement";
import { social } from "./social";

export const pollResult = {
  label: <FormattedMessage id="P_RESULT" />,
  // path: (tenantName) => `/${tenantName}/social/pollManagement`,
  path: (tenantName) => `/${tenantName}/social/pollManagement`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: social.name,
      path: `${social.path}`,
      onClick: () => navigate(`${social.path(tenantName)}`),
    },
    {
      key: 2,
      label: pollManagement.label,
      path: `${pollManagement.path}`,
      onClick: () => navigate(`${pollManagement.path(tenantName)}`),
    },
    {
      key: 3,
      label: pollResult.label,
      path: `${pollResult.path(tenantName)}`,
    },
  ],
};
